/**
 * Stałe dla typów wejściowych formularzy.
 */
export const InputTypeConstants = {
  TEXT: "text",
  TEXTAREA: "textarea",
  SELECT: "select",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  DATE: "date",
  DATETIME: "datetime",
  NUMBER: "number",
};
